import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from 'react-router-dom'

import logoDark from '../assets/images/logo-dark-tm.png'
import logoLight from '../assets/images/logo-light-tm.png'
import { AuthContext } from '../context/AuthContext';

export default function Navbar({ navDark, manuClass, containerClass }) {
    const [scroll, setScroll] = useState(false);
    const [isMenu, setisMenu] = useState(false);
    const [manu, setManu] = useState('');
    const location = useLocation();

    useEffect(() => {
        let current = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)
        setManu(current)

        const handleScroll = () => setScroll(window.scrollY > 50);
        window.addEventListener("scroll", handleScroll);
        window.scrollTo(0, 0);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [location.pathname]);

    const toggleMenu = () => setisMenu(!isMenu);

    // Navigation sections as JSON
        const { isAdmin } = useContext(AuthContext);
        const NAV_SECTIONS = [
            { label: "Home", to: "/" },
            { label: "Who we are", to: "/aboutus" },
            { label: "Contact Us", to: "/contact" },
        ];

    return (
        <header id="topnav" className={`${scroll ? "" : ""}nav-sticky navigation sticky`}>
            <style>{`
                @media (max-width: 991px) {
                    #topnav .logo img { height: 40px !important; }
                }
            `}</style>
            {/* Desktop: logo left, nav center/right; Mobile: logo right, hamburger left */}
            <div className={containerClass + " d-flex align-items-center justify-content-between"}>
                {/* Hamburger icon on the left (mobile only) */}
                <div className="menu-extras d-block d-lg-none order-1">
                    <div className="menu-item">
                        <button
                            className={`navbar-toggle${isMenu ? ' open' : ''}`}
                            id="isToggle"
                            onClick={toggleMenu}
                            aria-label={isMenu ? 'Close menu' : 'Open menu'}
                            aria-expanded={isMenu}
                            style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                margin: 0,
                                outline: "none"
                            }}
                        >
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                    </div>
                </div>
                {/* Logo: left on desktop, right on mobile */}
                <div
                    className="order-2 order-lg-1 flex-fill flex-lg-grow-0 d-flex align-items-center justify-content-between justify-content-lg-start"
                    style={{ flexWrap: 'nowrap' }}
                >
                    <Link className="logo" to="/">
                        {navDark === true ? (
                            <>
                                <img src={logoDark} height="45" className="logo-light-mode" alt="ArogyaVansh Logo" />
                                <img src={logoLight} height="45" className="logo-dark-mode" alt="ArogyaVansh Logo" />
                            </>
                        ) : (
                            <>
                                <span className="logo-light-mode">
                                    <img src={logoDark} className="l-dark" height="45" alt="ArogyaVansh Logo" />
                                    <img src={logoLight} className="l-light" height="45" alt="ArogyaVansh Logo" />
                                </span>
                                <img src={logoLight} height="50" className="logo-dark-mode" alt="ArogyaVansh Logo" />
                            </>
                        )}
                    </Link>
                    <a
                        href="https://web.docterz.in/#/clinics/5111/book_online_appointment"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary d-block d-lg-none"
                        style={{
                            backgroundColor: "#be5103",
                            color: "#fff",
                            border: "none",
                            padding: "8px 8px",
                            fontSize: "9px",
                            borderRadius: "6px",
                            textDecoration: "none"
                        }}
                >
                    Book Appointment
                </a>
                </div>
                {/* Main navigation for desktop */}
                <nav className="d-none d-lg-block flex-grow-1 order-lg-2 ms-4">
                    <ul className={`mb-0 ${manuClass} d-flex align-items-center justify-content-start`}>
                        {NAV_SECTIONS.map((item) => (
                            // mx-3
                            <li key={item.label} className={` ${manu === item.to.replace("/", "") ? "active" : ""}`}>
                                <Link to={item.to}>{item.label}</Link>
                            </li>
                        ))}
                            {isAdmin && (
                                <li className={` ${manu === "dashboard" ? "active" : ""}`}>
                                    <Link to="/dashboard">Dashboard</Link>
                                </li>
                            )}
                    </ul>
                </nav>
                {/* Book Appointment button - desktop only */}
                <div className="d-none d-lg-block order-lg-3 ms-3">
                    <a
                        href="https://web.docterz.in/#/clinics/5111/book_online_appointment"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                        style={{
                            backgroundColor: "#be5103",
                            color: "#fff",
                            border: "none",
                            padding: "8px 18px",
                            fontSize: "14px",
                            borderRadius: "6px",
                            textDecoration: "none",
                            whiteSpace: "nowrap"
                        }}
                    >
                        Book Appointment
                    </a>
                </div>
            </div>

            {/* Offcanvas navigation for mobile/left drawer */}
            <div className={`offcanvas offcanvas-start${isMenu ? " show" : ""} d-block d-lg-none`} tabIndex="-1" style={{ visibility: isMenu ? 'visible' : 'hidden', background: "#fff", zIndex: 1050 }}>
                <div className="offcanvas-header">
                    <button type="button" className="btn-close ms-auto" aria-label="Close" onClick={toggleMenu}></button>
                </div>
                <div className="offcanvas-body">
                    <ul className="list-unstyled">
                        {NAV_SECTIONS.map((item) => (
                            <li key={item.label} className={`mb-3 ${manu === item.to.replace("/", "") ? "active" : ""}`}>
                                <Link to={item.to} onClick={toggleMenu} className="nav-link">{item.label}</Link>
                            </li>
                        ))}
                        {isAdmin && (
                            <li className={`mb-3 ${manu === "dashboard" ? "active" : ""}`}>
                                <Link to="/dashboard" onClick={toggleMenu} className="nav-link">Dashboard</Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
            {/* Overlay for offcanvas */}
            {isMenu && <div className="offcanvas-backdrop fade show d-lg-none" onClick={toggleMenu}></div>}
        </header>
    )
}